module.exports = __webpack_public_path__ + "img/10.080c6946.jpg";